import { useSelector } from 'react-redux';
import { ProductCode, AccessLevel } from '@dev/ee-api/ee-api-models';
import { hasAccessLevel } from '@api/services/Security';
import { getProductCode } from '@api/store/products/actions';

type DashboardElementVisibliity = {
    settings: {
        isSettingsAccessTokensVisible: boolean;
        isSettingsPanelVisible: boolean;
    };
};

export const useDashboardElementVisibility = (): DashboardElementVisibliity => {
    const productCode = useSelector(getProductCode);

    const isCreatorProduct = productCode === ProductCode.CreatorSuite;

    return {
        settings: {
            isSettingsAccessTokensVisible: !isCreatorProduct && hasAccessLevel(AccessLevel.ViewAccessTokens),
            isSettingsPanelVisible: !isCreatorProduct,
        },
    };
};
